import { toast } from 'react-toastify';

import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

export const ADD_SHIPMENTS = 'addAdminShipments';
export const UPDATE_SHIPMENT = 'updateAdminShipment';

const API_SYSTEM_ADMIN_SHIPMENT_DATA_LISTS = 'shipment/data-lists';
const API_SYSTEM_ADMIN_SHIPMENT_ITEMS = 'shipment/self/:selfId';
const API_SYSTEM_ADMIN_SHIPMENT_EXPORT = 'shipment/export';

export const addAdminShipments = (shipments) => {
     return {
          type: ADD_SHIPMENTS,
          payload: shipments,
     };
};

export const updateAdminShipment = (shipment) => {
     return {
          type: UPDATE_SHIPMENT,
          payload: shipment,
     };
};

export const fetchAdminShipmentsRequest = (paginationPayload, setIsLoading) => (dispatch) => {
     const { filter, page, pageSize, sortBy, sortType } = paginationPayload;
     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     const endPoint = `${API_SYSTEM_ADMIN_SHIPMENT_DATA_LISTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     setIsLoading(true);
     callApi(endPoint, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addAdminShipments(response.data));
          })
          .finally(() => {
               setIsLoading(false);
          });
};

export const fetchAdminShipmentItemsRequest = (selfIdParam, nextDispatch) => () => {
     const selfId = selfIdParam.replace('#', '');
     const { setIsLoadingDetail, setShipmentItems } = nextDispatch;

     setIsLoadingDetail(true);

     callApi(API_SYSTEM_ADMIN_SHIPMENT_ITEMS.replace(':selfId', selfId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               setShipmentItems(response.data);
          })
          .finally(() => {
               setIsLoadingDetail(false);
          });
};

export const exportAdminShipmentsRequest = (exportPayload, setIsLoadingExport) => async () => {
     setIsLoadingExport(true);

     return await callApi(API_SYSTEM_ADMIN_SHIPMENT_EXPORT, 'POST', exportPayload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (!response.data) {
                    toast.success('No data to export excel file.');
                    return;
               }

               window.open(response.data);
               return true;
          })
          .finally(() => {
               setIsLoadingExport(false);
          });
};
